export default __webpack_public_path__ + "static/media/p7.ba7cdcb1.jpeg";